Alpine.magic('openCustomerArea', () => {
    return (url) => {
        if (window.innerWidth <= 640) {
            window.location.assign(url);

            return;
        }

        window.open(url, '_blank');

        window.location.reload();
    };
});

Alpine.magic('clipboard', () => {
    return (subject, message = null) => {
        navigator.clipboard.writeText(subject);

        window.$wireui.notify({
            title: message ?? 'Content copied to clipboard.',
            icon: 'success',
        });
    };
});

Alpine.magic('removeScroll', () => {
    return (remove = false) => {
        const event = new CustomEvent('remove-scroll');
        window.dispatchEvent(event);

        document
            .querySelectorAll('*[x-remove-scroll]')
            .forEach((el) =>
                remove
                    ? el.classList.remove('overflow-hidden', 'max-h-[90vh]', 'sm:max-h-[75vh]')
                    : el.classList.add('overflow-hidden', 'max-h-[90vh]', 'sm:max-h-[75vh]'),
            );
    };
});

Alpine.magic('downloadImage', () => {
    return (url, name, callback = null) => {
        const req = new XMLHttpRequest();
        req.open('GET', url, true);

        req.responseType = 'blob';

        req.onload = () => {
            if (req.status === 200) {
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(req.response);
                link.download = name;
                link.click();

                callback && callback();
            }

            if (req.status === 404) {
                window.$wireui.notify({
                    title: 'The high resolution version of this image is not available yet. Please try again later.',
                    icon: 'error',
                });

                callback && callback();
            }
        };

        req.send();
    };
});

Alpine.magic('openHires', () => {
    return (hire_link) => {
        const link = document.createElement('a');

        link.href = hire_link;
        link.target = '_blank';

        link.click();
    };
});

Alpine.magic('isMobileSafari', () => {
    let cached = null;

    return () => {
        if (cached === null) {
            const userAgent = navigator.userAgent;
            const isSafari =
                /Safari/.test(userAgent) && !/Chrome|CriOS|FxiOS|EdgiOS|OPiOS/.test(userAgent);
            const isMobileOrTablet =
                /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent) ||
                navigator.maxTouchPoints > 0 ||
                navigator.msMaxTouchPoints > 0;

            cached = isSafari && isMobileOrTablet;
        }

        return cached;
    };
});

Alpine.magic('openRequestPhotosModal', (_, { Alpine }) => {
    return () => {
        if (!Alpine.store('customerImages').count && !Alpine.store('cart').total) {
            window.$wireui.notify({
                title: `You must have photos in your album to request photos.`,
                icon: 'warning',
            });

            return;
        }

        window.dispatchEvent(new CustomEvent('open::request-photos-modal'));
    };
});
